import React from "react";
import { useConfig } from "@/context/ConfigContext";

// Holiday decorations are overlaid on top of the logo — the logo image itself is never altered.
const SantaHat = () => (
  <svg viewBox="0 0 100 100" aria-hidden="true"
    className="absolute -top-[42%] -left-[22%] w-[78%] h-[78%] pointer-events-none drop-shadow-md"
    style={{ transform: "rotate(-16deg)" }}>
    <path d="M20 66 Q26 24 72 30 Q64 50 60 66 Z" fill="#dc2626" />
    <path d="M20 66 Q26 24 72 30 Q58 34 44 40 Q30 48 20 66 Z" fill="#ef4444" />
    <rect x="12" y="62" width="56" height="16" rx="8" fill="#ffffff" />
    <circle cx="74" cy="28" r="10" fill="#ffffff" />
  </svg>
);

const WitchHat = () => (
  <svg viewBox="0 0 100 100" aria-hidden="true"
    className="absolute -top-[46%] -left-[20%] w-[80%] h-[80%] pointer-events-none drop-shadow-md"
    style={{ transform: "rotate(-14deg)" }}>
    <ellipse cx="50" cy="74" rx="44" ry="11" fill="#4c1d95" />
    <path d="M50 8 L74 70 Q50 60 26 70 Z" fill="#5b21b6" />
    <path d="M31 60 Q50 54 69 60 L66 70 Q50 63 34 70 Z" fill="#f59e0b" />
    <rect x="45" y="60" width="10" height="9" rx="1.5" fill="#1f2937" />
  </svg>
);

export function BrandLogo({ className = "h-9 w-9 rounded-xl shadow-md", alt = "OWEverit", testid }) {
  const { theme } = useConfig();
  const dec = theme?.decoration;
  return (
    <span className="relative inline-flex shrink-0" data-testid={testid ? `${testid}-wrap` : undefined}>
      <img src="/logo.png" alt={alt} className={className} data-testid={testid} />
      {dec === "christmas" && <SantaHat />}
      {dec === "halloween" && <WitchHat />}
    </span>
  );
}
